<template>
  <BaseTooltip
    position="up"
    :text="this.input.validations.message"
    :show="showTooltip"
    :class="{
      [$style.baseTextareaWrapper]: true
    }"
  >
    <textarea
      type="text"
      v-model="$v.selectedValue.$model"
      :placeholder="input.label"
      rows="5"
      cols="50"
      @blur="onChange"
      @input="onInput"
      :class="{
        [$style.baseTextarea]: true,
        [$style.baseTextareaNewDesign]: isNewDesign,
        [$style.invalid]: isInvalid
      }"
    >
    </textarea>
  </BaseTooltip>
</template>

<script>
import store from '@/store'
import { validationMixin } from 'vuelidate'
import { maxLength } from 'vuelidate/lib/validators'
import { noAngleBrackets } from '../../helpers/validation-helper'
import BaseTooltip from '@/components/ui/BaseTooltip.vue'

export default {
  props: {
    input: {
      type: Object,
      required: true
    }
  },
  mixins: [validationMixin],
  components: {
    BaseTooltip
  },
  data() {
    return {
      selectedValue: '',
      isInvalid: false,
      showTooltip: false,
      timeout: null,
      isBlur: false
    }
  },
  validations() {
    if (this.input.validations) {
      return {
        selectedValue: {
          noAngleBrackets: this.input.validations.noAngleBrackets
            ? noAngleBrackets
            : '',
          required: this.input.validations.required ? required : '',
          email: this.input.validations.email ? email : '',
          minLength: this.input.validations.minLength
            ? minLength(this.input.validations.minLength)
            : '',
          maxLength: this.input.validations.maxLength
            ? maxLength(this.input.validations.maxLength)
            : '',
          numeric: this.input.validations.numeric ? numeric : '',
          minOneNumber: this.input.validations.minOneNumber ? minOneNumber : ''
        }
      }
    }
  },
  computed: {
    // note: new design
    isNewDesign() {
      return store.getters.hausankerDesign
    }
  },
  methods: {
    onChange() {
      this.isBlur = true
      this.checkValidation()
      const data = {
        slideName: this.input.slideName,
        formName: this.input.formName,
        value: this.selectedValue,
        isInvalid: this.isInvalid,
        name: this.input.name
      }
      this.$emit('onTextarea', data)
    },
    onInput() {
      if (this.isBlur) {
        this.checkValidation()
      }
    },
    checkValidation() {
      if (this.$v.selectedValue.$invalid && this.$v.selectedValue.$anyDirty) {
        this.isInvalid = true
        this.showTooltip = true
      } else {
        this.isInvalid = false
        this.showTooltip = false
      }
    }
  },
  created() {
    this.selectedValue = this.input.selectedValue
  },
  beforeDestroy() {
    clearTimeout(this.timeout)
  }
}
</script>

<style lang="scss" module>
@import '@/scss/variables.scss';

.baseTextareaWrapper {
  width: 100%;
  margin-bottom: 20px;
}
.baseTextarea {
  width: 100%;
  color: $color_font_3;
  padding-top: 9px;
  padding-left: 21px;
  font-family: inherit;
  font-size: 18px;
  border: 2px solid $color_grey_3;
}

// note: new design
.baseTextareaNewDesign {
  border: 2px solid $color_border_new;
}

.baseTextarea:focus {
  outline: none;
  border: 2px solid $color_green_2;
}

// note: new design
.baseTextareaNewDesign:focus {
  outline: none;
  border: 2px solid $color_border_dark_new;
}

.baseTextarea::-webkit-input-placeholder {
  color: $color_font_4;
}

.invalid {
  border: 2px solid $color_error;
}
</style>
